<template>
  <a-modal
    :open="props.open"
    @ok="handleOk"
    @cancel="handleCancel"
    :footer="false"
    :wrap-style="{ overflow: 'hidden' }"
    ref="modalRef"
    wrapClassName="delete-slot-modal"
  >
    <div class="slots-modal">
      <div class="icon">
        <DeleteOutlined />
      </div>
      <div>
        <h3 v-if="record?.user_data?.role === 'Administrador'">
          ¿Estás seguro de eliminar este slot de tu equipo de trabajo?
        </h3>
        <h3 v-else>
          ¿Estás seguro de eliminar este slot e inactivar al usuario “{{
            record?.user_data?.fullname
          }}”?
        </h3>
      </div>
      <p v-if="slots?.slot_type_billing === 'Prepago'">
        Recuerda que, si eliminas slots durante tu ciclo de facturación, estos ya se encuentran
        prepagados. Te recomendamos realizar esta acción tu último día de facturación. Si necesitas
        agregar usuarios,
        <span>
          también puedes únicamente inactivar alguno existente para tener slots disponibles.
        </span>
      </p>
      <p v-if="slots?.slot_type_billing === 'Postpago'">
        Recuerda que, al eliminar slots durante tu ciclo de facturación, estos ya están programados
        para ser incluidos en tu factura al final del mes. Te sugerimos llevar a cabo esta acción en
        tu último día de facturación para que el siguiente mes solo te cobren por los slots que
        tengas en ese momento.
      </p>
      <div class="actions">
        <p>Escribe la palabra <strong>“Eliminar”</strong></p>
        <a-input type="text" placeholder="Escribe aquí" v-model:value="letter" />
        <a-button
          :class="`${letter === 'Eliminar' ? 'btn-delete' : 'disabled'}`"
          type="primary"
          :disabled="disabled"
          @click="deleteSlot()"
          :loading="loading"
        >
          Eliminar Slots
        </a-button>
      </div>
    </div>
  </a-modal>
  <UnsuccessModal :visible="showErrorModal" @update:visible="handleUpdateModal" :slots="slots" />
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { DeleteOutlined } from "@ant-design/icons-vue";
import SlotManager from "@/app/settings/services/slots/SlotManager";
import { message } from "ant-design-vue";
import UnsuccessModal from "@/app/settings/components/modals/UnsuccessModal.vue";
import EventBus from "@/app/shared/utils/eventBus";

const props = defineProps({
  open: Boolean,
  state: String,
  record: Object,
  slots: Object,
  fetchSlotsTableData: Function,
});
const letter = ref("");
const disabled = ref(true);
const showErrorModal = ref(false);
const loading = ref(false);

const manager = new SlotManager();

const emit = defineEmits(["update:open"]);

const handleOk = () => {
  letter.value = "";
  emit("update:open", false);
};

const handleCancel = () => {
  letter.value = "";
  emit("update:open", false);
};

const success = () => {
  message.success("Se ha eliminado el slot con éxito");
};

const ErrorModal = () => {
  emit("update:open", false);
  console.log(showErrorModal, "showErrorModal");
  showErrorModal.value = true;
};

const handleUpdateModal = (isOpen: any) => {
  showErrorModal.value = isOpen;
};

const fetchData = () => {
  if (typeof props.fetchSlotsTableData === "function") {
    props.fetchSlotsTableData();
  }
};

const deleteSlot = async () => {
  loading.value = true;
  const id = props?.record?.id;
  await manager
    .deleteSlots(id)
    .then(() => {
      handleOk();
      success();
      letter.value = "";
      loading.value = false;
      EventBus.emit("updateSlots");
      fetchData();
    })
    .catch(() => {
      loading.value = false;
      ErrorModal();
    });
};

watch(letter, () => {
  if (letter.value === "Eliminar") {
    return (disabled.value = false);
  }
  return (disabled.value = true);
});
</script>
<style lang="sass" scoped>
.ant-modal-body
  .input
    &-message
      width: 100%
      border: 1px solid $gray-5
      border-radius: 4px
      height: 32px
      padding: 0 9px
  .anticon
    &-delete
      font-size: 64px
      color: $red-6
.slots
  &-modal
    display: flex
    flex-direction: column
    gap: 15px
    text-align: center

    p
      span
        font-weight: 600
        color: #51555A
    .actions
      display: flex
      flex-direction: column
      gap: 15px
      p
        text-align: left
        margin: 0
    button
      width: 100%
</style>
